module.exports = __webpack_public_path__ + "static/img/hangle.33dbe2f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hangle.png
// module id = ATfK
// module chunks = 313